export default __webpack_public_path__ + "static/media/canvas.44e703b8.jpg";